const config = {
  host:
    window.location.href.includes("localhost") ||
    window.location.href.includes("dev")
      ? "dev.bleustay.com"
      : window.location.href.includes("stg")
        ? "stg.bleustay.com"
        : "bleustay.com",
  backendUrl: window.location.href.includes("localhost")
    ? "http://localhost:3000"
    : window.location.href.includes("dev")
      ? "https://merchant.dev.bleustay.com"
      : window.location.href.includes("stg")
        ? "https://merchant.stg.bleustay.com"
        : "https://merchant.bleustay.com",
};

export default config;
